import React, { useState } from 'react'
import { Pagination, Payload, Result, SearchSpringProductResponse } from '../../search-spring/types/types'
import InstantSearchGrid from '../../search-spring/components/InstantSearchGrid'
import { convertSearchSpringProductPricingToMarketPrice, isSearchSpringProductResponse, standardSearch } from '../../helpers/searchSpringHelpers'
import PaginationBar from './PaginationBar'
import CollectionSearchGrid from '../../search-spring-collection/components/CollectionSearchGrid'

type Props = {
  pagination: Pagination
  products: Result[]
  searchQuery: string
  payload: Payload,
  isSearchPage?: boolean
}

declare var Shopify: { currency: { active: string } }
const updatePageUrl = (pageNumber: number | null) => {
  if (!pageNumber) return
  const url = new URL(window.location.href)
  url.searchParams.set('page', pageNumber.toString())
  window.history.pushState({}, '', url)
}

const PaginationService = ({pagination, products, searchQuery, payload, isSearchPage = true}: Props) => {
  const [searchPageProducts, setSearchPageProducts] = useState<Result[]>(products)
  const [nextPage, setNextPage] = useState<number | null>(pagination.nextPage)
  const [currentProductCount, setCurrentProductCount] = useState<number>(pagination.end)
  const [error, setError] = useState(false)
  const isCollectionSearch = isSearchPage == false ? true : false
  // TODO: handle push state, pop state here
  
  const loadMoreProducts = async () => {
    const updatedPayload: Payload = {
      ...payload
    }
    if (nextPage) {
      updatedPayload.page = nextPage
    }

    try {
      const response: SearchSpringProductResponse | unknown = await standardSearch({searchQuery: searchQuery, payload: updatedPayload, searchType: isCollectionSearch ? 'collection' : 'search' })          
      if (isSearchSpringProductResponse(response)) {
        if (Shopify.currency.active != "AUD") {
          const newproductData: SearchSpringProductResponse = await convertSearchSpringProductPricingToMarketPrice(response)
          // Incase the product conversion fails just put in the AU price, the PDP and cart will show correct prices.
          const newProducts = newproductData.results ? newproductData.results : response.results
          setSearchPageProducts(prev => prev = [...prev, ...newProducts])
        } else {
          setSearchPageProducts(prev => prev = [...prev, ...response.results])
        }
        pagination.nextPage ? setNextPage(prev => prev = response.pagination.nextPage) : setNextPage(null)
        setCurrentProductCount(prev => prev = response.pagination.end)
        
        requestAnimationFrame(() => {
          // Updating page param.
          updatePageUrl(updatedPayload.page || null)
          window.scrollTo(0, scrollY)
        })
      } else {
        setError(true)
        throw new Error 
      } 
    } catch (error) {
      setError(true)
    }
  }

  const ComponentHandler = (): JSX.Element => {
    if (error) {
      return <div className="text-lg font-bstSpyre mt-4 text-center mx-5">Sorry, there was an error getting more products. Please try again later or contact us if this issue persists.</div>
    }

    return <>
      {searchPageProducts.length > 0 ? (
        isCollectionSearch ? (
          <CollectionSearchGrid products={searchPageProducts} />
        ) : (
          <InstantSearchGrid products={searchPageProducts} />
        )
      ) : (
        <div className="text-lg font-bstSpyre my-4 text-center mx-5">
          If you are not seeing any results, try removing some of your selected filters.
        </div>
      )}
      
      {nextPage ? 
        <div className='flex flex-col items-center my-LG md:my-DLG'>
          <div className='font-calibre text-sm-b uppercase text-black'>{`${currentProductCount} of ${pagination.totalResults}`}</div>
          
          <div className='mb-SM md:mb-DSM'>
          <PaginationBar currentProductCount={currentProductCount} totalResults={pagination.totalResults} maxWidth={210} tailwindClass='mt-2'/>
          </div>

          <button onClick={loadMoreProducts} className="Button Button--secondary-dark uppercase backdrop-filter-none min-w-[150px] h-[35px] md:h-[44px] font-calibre text-sm-b text-black hover:text-white">Load More</button>
        </div>
        :
        null
      }
    </>
  }

  return (
    <ComponentHandler />
  )
}

export default PaginationService